import { useEffect, useState } from "react"
import MainLayout from "../../components/layouts/MainLayout"
// import { EyeIcon, EyeSlashIcon } from '@heroicons/react/solid';
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { providerApi } from "../../api/providerApi";
import Swal from "sweetalert2";
import { message } from "antd";
import { AdminApi } from "../../api/adminsApi";


const CreateAdminView = () => {
    const [roles, setRoles] = useState([])
    const [formData, setFormData] = useState({
        name: '',
        lastname: '',
        email: '',
        role_id: '',
        password: '',
        
    })
    const [loading, setLoading] = useState(false);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const abortController = new AbortController()


    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible); // Alterner la visibilité du mot de passe
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const fetchRoles = async () => {
        try {
            const res = await AdminApi.getRoles(abortController.signal)

            console.log(res)

            if (!res.success) {
                return message.error('Recuperation des roles impossible');
            }

            setRoles(res.data)
        } catch (error) {
            message.error('Une erreur est survenue lors de la recuperation des roles');
        }
        
    }
   

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        if (!formData.role_id ||  formData.role_id =='') {
            setLoading(false);

          return message.error('Renseignez le niveau de permission');            
        }

        try {
          console.log(formData)

          const payload = {
            name:formData.name,
            lastname: formData.lastname,
            email: formData.email,
            role_id: formData.role_id,
            password: formData.password
          }

          const res = await AdminApi.storeAdmin(JSON.stringify(payload),abortController.signal)

          console.log(res)

          if (!res.success) {
            return Swal.fire({
              title:'Impossible d\'enregistrer',
              text:res.message,
              // timer:3000
            })
          }

          message.success('Admin ajouté avec succès');
          setFormData({
            name: '',
            lastname: '',
            email: '',
            role_id: '',
            password:''
          });
        } catch (error) {
          message.error('Une erreur est survenue lors de l\'ajout de l\'admin');
        } finally {
          setLoading(false);
        }
    }

    useEffect(()=>{
        fetchRoles()
    },[])

    return <MainLayout>
        <div className="max-w-lg mx-auto p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-2xl font-bold mb-4">Ajouter un admin</h2>
      <form onSubmit={handleSubmit}>
        {/* Informations Utilisateur */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Nom <span className="text-red-600 text-sm italic">(Obligatoire)</span> </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Prénom <span className="text-red-600 text-sm italic">(Obligatoire)</span></label>
          <input
            type="text"
            name="lastname"
            value={formData.lastname}
            onChange={handleChange}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
          />
        </div>
        
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Email <span className="text-red-600 text-sm italic">(Renseigner s'il a une adresse email)</span></label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Niveau de permission <span className="text-red-600 text-sm italic">(Optionnel)</span></label>
          <select 
            name="role_id"
            value={formData.role_id}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-md">
                <option value="">Choisir</option>
                {
                    roles?.map((role, index) => 
                        <option key={index} value={role.id}>{role.name}</option>
                    )
                }
                
          </select>
          
        </div>
        
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Mot de passe <span className="text-red-600 text-sm italic">(Obligatoire)</span></label>
          <div className="relative">
            <input
              type={passwordVisible ? 'text' : 'password'} // Si passwordVisible est true, on affiche le mot de passe, sinon on le cache
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-md"
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className="absolute inset-y-0 right-0 flex items-center px-3 text-gray-600"
            >
              {passwordVisible ? (
                <EyeInvisibleOutlined className="h-5 w-5" />
              ) : (
                <EyeOutlined className="h-5 w-5" />
              )}
            </button>
          </div>
        </div>

        {/* Soumission */}
        <div className="mt-6">
          <button
            type="submit"
            className="w-full px-4 py-2 bg-africasa-secondary text-white rounded-md hover:bg-africasa-primary"
            disabled={loading}
          >
            {loading ? 'Enregistrement...' : 'Ajouter'}
          </button>
        </div>
      </form>
    </div>
    </MainLayout>
}
export default CreateAdminView